import React from 'react'
import NavigationTabs from '../nav/NavigationTabs';
import Moment from "react-moment"
import RevenueBreakDown from './RevenueBreakDown';

export default class Statements extends React.Component {
  state = {
    dataLoaded: false,
    showRevenueBreakDown: false,
    year: '',
    month: ''
  }

  componentDidMount(){
    const { user, fetch } = this.props;
    fetch(user._id).then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true
      })
    })
  }

  viewBreakDown = (year, month)  => {
    this.setState({
      showRevenueBreakDown: true,
      year,
      month
    })
  }

  hideBreakDown = () => {
    this.setState({
      showRevenueBreakDown: false
     })
  }


  render() {
    const { dataLoaded, showRevenueBreakDown } = this.state;
    const { statements } = this.props;
    return (
      <div>
        <NavigationTabs
          title="Settings"
          set="settings"
          subtitle="Statements"
          currentUser={this.props.currentUser}
          activeRoute="/settings/statements"/>
        {
          dataLoaded ? (
            <div>
              <table className="statement-table">
                <thead>
                  <tr>
                    <td>Pay Date</td>
                    <td style={{'width': '200px'}}>Pay Period</td>
                    <td>Description</td>
                    <td>Amount Paid</td>
                  </tr>
                </thead>
                <tbody>

                   {
                    Object.values(statements).map((statement, index) => {
                      let createdDate = new Date(statement.createdAt);
                      let month = createdDate.getMonth() + 1;
                      let year = createdDate.getFullYear();
                      return (<tr key={index}>
                        <td><Moment className="text-muted" format="MMMM Do YYYY">{statement.payDate}</Moment></td>
                        <td style={{ 'width': '200px' }}>
                          <Moment className="text-muted" format="MMMM YYYY">{statement.createdAt}</Moment>
                        </td>
                        <td>
                          {statement.description}
                          <br />
                          <a onClick={() => this.viewBreakDown(year, month)}  style={{ cursor: 'pointer' }}>View Statement</a>
                        </td>
                        <td>${statement.sum && statement.sum.toFixed(1)}</td>
                      </tr>)
                    })
                  }
                  {showRevenueBreakDown && <RevenueBreakDown show={showRevenueBreakDown} year={this.state.year} month={this.state.month} hideBreakDown = {this.hideBreakDown} />}
                </tbody>
              </table>
            </div>
          ) : null

        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/Statements.js